import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';

export const TEXT_TRUNCATE_THRESHOLD = 150;

export const truncateWithTooltip = (text, threshold = TEXT_TRUNCATE_THRESHOLD) => {
    if (!text) return '';
    if (typeof text !== 'string') return text;
    if (text.length <= threshold) return text;
    return (
        <Tooltip title={text} arrow>
            <span style={{cursor: 'help'}}>
                {text.substring(0, threshold)}...
            </span>
        </Tooltip>
    );
};

export const wrapWithTooltipIfLong = (
    value,
    content,
    threshold = TEXT_TRUNCATE_THRESHOLD
) => {
    const isLong = typeof value === 'string' && value.length > threshold;
    if (!isLong) return content;
    return (
        <Tooltip title={value} arrow placement="top-start">
            {content}
        </Tooltip>
    );
};
